const allMxStepContent = [
  [
    // "intent://coinlist.co#Intent;scheme=http;package=com.android.browser;end" onclick="aRegister()"
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step1.webp',
      key:  'Paso 1',
      content: `<p>
        Abre <a href="https://coinlist.co">coinlist.co</a> y ve la página principal como se muestra a continuación. Y luego haz clic en "Comenzar" para iniciar el registro.
      </p>`
    },
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step2.webp',
      key:  'Paso 2',
      content: `<p>
      Completa la información básica y haz clic en "crear cuenta". Te sugerimos primero crear una nueva cuenta de Gmail y colocar la nueva cuenta en la columna "Tu dirección de correo electrónico". De esta manera, la cuenta no afectará tu dirección de correo electrónico de uso frecuente.
      </p>`
    }
  ],
  [
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step3.webp',
      key:  'Paso 3',
      content: `<p>
        Verificación de correo electrónico
      </p>`
    },
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step4.webp',
      key:  'Paso 4',
      content: `<p>
        Una vez que se haya verificado tu dirección de correo electrónico, continuarás a la página de abajo mostrando que se ha registrado correctamente. Luego haz clic en el botón "Comprar y vender" para continuar
      </p>`
    }
  ],
  [
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step5.webp',
      key:  'Paso 5',
      content: `<p>
        Haz clic en el botón "Verificar" para verificar tu identidad
      </p>`
    },
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step6.webp',
      key:  'Paso 6',
      content: `<p>
        Ingresa tu nombre (s) de acuerdo con las instrucciones y haz clic en el botón "Guardar y continuar"
      </p>`
    }
  ],
  [
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step7.webp',
      key:  'Paso 7',
      content: `<p>
        Elije tu país de residencia y luego haz clic en el botón "Guardar y continuar".
      </p>`
    },
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step8.webp',
      key:  'Paso 8',
      content: `<p>
        Ingresa tu código postal, fecha de nacimiento, número de teléfono y luego haz clic en el botón "Guardar y continuar".
      </p>`
    }
  ],
  [
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step9.webp',
      key:  'Paso 9',
      content: `<p>
        Ahora es el momento de comenzar a verificar tu identificación. Prepara tu identificación y haz clic en el botón "Iniciar".
      </p>`
    },
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step10.webp',
      key:  'Paso 10',
      content: `<p>
        Una vez que hayas terminado de tomar la foto de tu identificación, pasarás a la verificación facial como se muestra a continuación. Tómate una buena selfie.😆
      </p>`
    }
  ],
  [
    {
      img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step11.webp',
      key:  'Paso 11',
      content: `<p>
        Es el último paso. Puedes detenerte aquí sin avanzar. Después de compartir la información requerida, tomaremos 7 días para verificar y hacerte saber el resultado final.
      </p>`
    }
  ],
]
// const allNgStepContent = [
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step1.webp',
//       key:  'Step 1',
//       content: `<p>
//         Open <a href="intent://coinlist.co#Intent;scheme=http;package=com.android.browser;end">coinlist.co</a> and see the mainpage as below. And then click “Get Started” to start the trip of registration.
//       </p>`
//     },
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step2.webp',
//       key:  'Step 2',
//       content: `<p>
//         Fill in the basic info below and click “create account”. <br/>We suggest you to create a new gmail account first and put the new gmail account in the “Your Email Address” column. In this way, the account will not affect your frequently used email address. 
//       </p>`
//     }
//   ],
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step3.webp',
//       key:  'Step 3',
//       content: `<p>
//         Email Verification
//       </p>`
//     },
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step4.webp',
//       key:  'Step 4',
//       content: `<p>
//         Once you verified your email address, it will jump to the page below showing that you have signed up successfully. Then click “Buy&Sell” button to continue
//       </p>`
//     }
//   ],
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step5.webp',
//       key:  'Step 5',
//       content: `<p>
//         Click “Verify” button to verify your identity
//       </p>`
//     },
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step6.webp',
//       key:  'Step 6',
//       content: `<p>
//         Input your names according to the instructions and click “Save&Continue” Button.
//       </p>`
//     }
//   ],
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step7.webp',
//       key:  'Step 7',
//       content: `<p>
//         Choose your country of residence and then click “Save&Continue” button.
//       </p>`
//     },
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step8.webp',
//       key:  'Step 8',
//       content: `<p>
//         Input your postal address, date of birth and phone number and then click “Save&Continue” button.
//       </p>`
//     }
//   ],
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step9.webp',
//       key:  'Step 9',
//       content: `<p>
//         Now it is time to start verify your ID. Please prepare you ID and click “Start” button.
//       </p>`
//     },
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step10.webp',
//       key:  'Step 10',
//       content: `<p>
//         After you are done with taking the photo of your ID, you will move to face verification as below. Take a good shot.😆
//       </p>`
//     }
//   ],
//   [
//     {
//       img: 'https://static-mx.obs.myhuaweicloud.com/web/app-h5/img/register-coinlist/step11.webp',
//       key:  'Step 11',
//       content: `<p>
//         it is the last step. You can stop here without moving forward. After you share the required information, we will take 7 days to verify and let you know the final result.
//       </p>`
//     }
//   ],
// ]

// const ng = {
//   pageTitle: 'Register Coinlist',
//   btnMsg: 'Verify Coinlist Info',
//   tip: 'How to Register in Coinlist?',
//   headerMsg: 'The following steps are from the mobile version. You can either use mobile or PC to register.',
//   headerATag: 'Click here to register',

//   mainContent: allStepContent,

//   footerTitle: 'Key Notice',
//   footerContent: `
//     <li>1.Fake information will lead to the failure of registration</li>
//     <li>2.No worry about the privacy. Your data is stored in Coinlist which has a very strong privacy policy.</li>
//     <li>3.Try some more times if you fail in any step. According to our experience, the registration is smooth.</li>
//   `
// }

const mx = {
  pageTitle: 'Registrarte en Coinlist',
  btnMsg: 'Verificar',
  tip: '¿Cómo registrarte en Coinlist?',
  headerMsg: 'Los siguientes pasos son de la versión de celular. Puedes usar el celular o la PC para registrarte.',
  headerATag: 'Haz click aquí para registrarte.',

  mainContent: allMxStepContent,

  footerTitle: 'Consejos clave',
  footerContent: `
    <li>1.La información falsa derivará a la falla del registro</li>
    <li>2.No te preocupes por la privacidad. Tus datos se almacenan en Coinlist, que tiene una política de privacidad muy confiable.</li>
    <li>3.Inténtalo más veces si fallas en algún paso. Según nuestra experiencia, el registro es fluido.</li>
  `
}

export const appMap = {
  default: mx
}

